import { render, staticRenderFns } from "./calcMain.vue?vue&type=template&id=0aab3fb2"
import script from "./calcMain.vue?vue&type=script&lang=js"
export * from "./calcMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports